// extracted by mini-css-extract-plugin
module.exports = {"container":"_2ae4a07","item":"_7f2bd63","singleDetails":"_2dfae13","singleDetailsDate":"_835a130","selection":"_d724526"};